import React from 'react';
import PropTypes from 'prop-types';
import ChargeRow from 'chargeComponents/ChargeRow';
import ChargeSelect from 'chargeComponents/ChargeSelect';

class ChargeSelectGroup extends React.Component {

    constructor(props) {
        super(props);

    }

    render() {

        const {groupedItems, orderId, chargeActions, disabled} = this.props;
        if (!groupedItems) {
            return null;
        }

        let message = '',
            error = '',
            loading = false,
            hasUnsavedChanges = false;
        const options = [];

        groupedItems.forEach((charge, index) => {

            if (charge.get('message')) {
                message = message += charge.get('message');
            }
            if (charge.get('error')) {
                error = error += charge.get('error');
            }

            if (charge.get('loading')) {
                loading = true;
            }

            if (charge.get('hasUnsavedChanges')) {
                hasUnsavedChanges = true;
            }

            options.push((<ChargeSelect
                disabled={disabled}
                showTitle={false}
                orderId={orderId}
                chargeActions={chargeActions}
                key={'charge_select_' + index}
                charge={charge}/>));

        });

        const option = (
            <table>
                <tbody>
                    {options}
                </tbody>
            </table>
        );

        return (<ChargeRow
            hasUnsavedChanges={hasUnsavedChanges}
            title={groupedItems
            .first()
            .get('description')}
            option={option}
            loading={loading}
            message={message}
            error={error}/>);
    }
}

ChargeSelectGroup.propTypes = {
    groupedItems: PropTypes.object,
    chargeActions: PropTypes.object,
    orderId: PropTypes.string,
    disabled: PropTypes.bool

};
export default ChargeSelectGroup;


// WEBPACK FOOTER //
// ./src/components/charges/ChargeSelectGroup.js